import React, { useEffect, useState } from "react";
import { classNames } from "primereact/utils";
import styles from "./AnimatedField.module.scss";

interface IAnimatedFieldProps {
  className?: string;
  children: React.ReactNode;
}

export const AnimatedField = ({ className, children }: IAnimatedFieldProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let id1: number;
    let id2: number;
    id1 = requestAnimationFrame(() => {
      id2 = requestAnimationFrame(() => setIsVisible(true));
    });
    return () => {
      cancelAnimationFrame(id1);
      cancelAnimationFrame(id2);
    };
  }, []);

  return (
    <div className={classNames(styles.root, isVisible && styles.visible, className)}>
      {children}
    </div>
  );
};
